import { render } from "./rightMenu.vue?vue&type=template&id=0b31c302&scoped=true&lang=pug"
import script from "./rightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./rightMenu.vue?vue&type=script&setup=true&lang=js"

import "./rightMenu.vue?vue&type=style&index=0&id=0b31c302&scoped=true&lang=css"
import "./rightMenu.vue?vue&type=style&index=1&id=0b31c302&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b31c302"]])

export default __exports__